<template>
  <div class="productsOverLimitWithLegacySubscriptionBanner">
    <b-row v-if="ShowProductsOverLimitWithLegacySubscriptionBannerEnabled">
      <b-alert
        :show="ShowProductsOverLimitWithLegacySubscriptionBannerEnabled"
        variant="info"
        class="flex-grow-1 w-100"
      >
        <h5><i class="far fa-info-circle fa-lg" /> {{ $t('xWeHaveUpdatedOurProductLimits') }}</h5>
        <p class="bannerBody ml-4">
          {{ $t('xProductsOverLimitWithLegacySubscriptionExistingUser') }}
          <a
            class="p-0 fw-bold learnMore hoverPointer"
            @click="$bvModal.show('products-over-limit-with-legacy-subscription-modal')"
            >{{ $t('xLearnMoreLowercase') }}.</a
          >
        </p>
      </b-alert>
    </b-row>
    <b-modal id="products-over-limit-with-legacy-subscription-modal" centered size="lg">
      <template #modal-header>
        <b-row class="w-100 justify-content-between py-0" align-v="center" no-gutters>
          <h2 class="modal-title"><i class="far fa-info-circle fa-md" /> {{ $t('xWeHaveUpdatedOurProductLimits') }}</h2>
          <b-button class="btn btn-icon-button btn-icon-button--gray" @click="closeModal()">
            <i class="fas fa-times" />
          </b-button>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button @click="navToSupportPage()" variant="secondary" data-test-hook="contact-support-button">
          {{ $t('xContactSupport') }}
        </b-button>
        <b-button @click="closeModal()" variant="primary" data-test-hook="done-button">
          {{ $t('xDone') }}
        </b-button>
      </template>
      <div>
        <p class="mb-4">{{ $t('xProductsOverLimitWithLegacySubscriptionExistingUser') }}</p>
        <strong>{{ $t('xPleaseNote') }}</strong>
        <ul>
          <li v-for="n in 2" :key="n">{{ $t(`xProductsOverLimitWithLegacySubscriptionModalItem${n}`) }}</li>
        </ul>
        <p class="mt-4">{{ $t('xThankYouForBeingAValuedUser') }}</p>
        <p class="mt-4">{{ $t('xIfYouHaveQuestionsContactSupport') }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['ShowProductsOverLimitWithLegacySubscriptionBannerEnabled'],
  methods: {
    closeModal() {
      this.$bvModal.hide('products-over-limit-with-legacy-subscription-modal')
    },
    navToSupportPage() {
      this.closeModal()
      this.$appInsights.trackEvent({
        name: 'click-contact-support-settings-subscription-modal',
        properties: {}
      })
      this.$router.push({
        path: `/support`
      })
    }
  }
}
</script>
<style lang="scss">
.productsOverLimitWithLegacySubscriptionBanner {
  width: 100%;
  padding: 0 1rem;
}
.modal-header {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.bannerBody {
  font-weight: normal;
}
.learnMore {
  font-weight: bold !important;
  color: var(--carbon-900) !important;
}
</style>
